import "./style.css";

export default class SelectBox {
  static selector = ".select-box";

  constructor(block) {
    this.block = block;
    this.select = this.block.querySelector("select");
    this.nativeOptions = [...this.select.options];
    this.display = this.block.querySelector(".select-box__display");
    this.optionsList = this.block.querySelector(".select-box__options");
    this.options = [...this.block.querySelectorAll(".select-box__option")];
  }

  open = () => {
    // refresh selected items
    this.options.forEach((o) =>
      o.classList.remove("select-box__option--selected")
    );
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (selectedOption) {
      const fakeOptionElement = this.options.find(
        (o) => o.innerHTML === selectedOption.innerHTML
      );
      if (fakeOptionElement) {
        fakeOptionElement.classList.add("select-box__option--selected");
      }
    }

    this.block.classList.add("select-box--active");

    window.addEventListener("click", this.handleWindowClick, true);
  };
  close = () => {
    this.block.classList.remove("select-box--active");

    window.removeEventListener("click", this.handleWindowClick, true);
  };

  closeAllSelectBoxes = () => {
    const allSelectBoxes = [...document.querySelectorAll(".select-box--open")];

    allSelectBoxes
      .filter((sb) => sb !== this.block)
      .forEach((sb) => {
        sb.classList.remove("select-box--open");
      });
  };

  handleDisplayClick = (e) => {
    // avoid click on underneath select
    e.stopPropagation();

    // close all the other select boxes
    this.closeAllSelectBoxes();

    if (this.block.classList.contains("select-box--active")) {
      this.close();
    } else {
      this.open();
    }
  };
  handleFakeOptionClick = (e) => {
    // get clicked option and its value
    const fakeOptionElement = e.target;
    const optionValue = fakeOptionElement.dataset.value;

    // update native select box
    this.select.selectedIndex = this.nativeOptions.findIndex(
      (o) => o.value === optionValue
    );

    // update display element (the selected value shown)
    this.display.innerHTML =
      this.select.selectedIndex >= 0
        ? fakeOptionElement.innerHTML
        : this.nativeOptions.length
        ? this.nativeOptions[0].innerHTML
        : "--";

    // update set the current fake option as selected and unselect the others
    this.options.forEach((o) =>
      o.classList.remove("select-box__option--selected")
    );
    fakeOptionElement.classList.add("select-box__option--selected");

    // fire change event on native select (it is not fired when change its value
    // programmatically)
    if ("createEvent" in document) {
      const event = document.createEvent("HTMLEvents");
      event.initEvent("change", false, true);
      this.select.dispatchEvent(event);
    } else {
      this.select.fireEvent("onchange");
    }

    this.close();
  };

  handleWindowClick = (e) => {
    const closestSelectBox = e.target.closest(".select-box");

    if (closestSelectBox === this.block) {
      return;
    }

    this.close();
  };

  // Lifecycle methods
  onReady() {
    // init display element (where the selected value is shown)
    this.display.addEventListener("click", this.handleDisplayClick);

    // init fake options list
    this.options.forEach((o) => {
      o.addEventListener("click", this.handleFakeOptionClick);
    });
  }
  onResize() {}
  onScroll() {}
  onDestroy = () => {
    // destroy display element (where the selected value is shown)
    this.display.removeEventListener("click", this.handleDisplayClick);

    // destroy fake options list
    this.options.forEach((o) => {
      o.removeEventListener("click", this.handleFakeOptionClick);
    });

    window.removeEventListener("click", this.handleWindowClick, true);
  };
}
